module.exports = __webpack_public_path__ + "img/trade-service-parts-display-red.7dc134f1.png";